import { createSelector } from 'reselect'

import * as locationSelectors from 'services/Location/selectors'

import { AppState } from 'reducers'
import { StoreFiltersState } from './typings'
import getConstants from '../../constants'
import {
  getAccessibilitySpecificFilters,
  getBrandSpecificFilters,
} from './utils'

export const root = (state: AppState) => state.stores

export const totalCount = (state: AppState) => state.stores.totalCount

export const results = (state: AppState) => state.stores.results

export const entities = (state: AppState) => state.stores.entities

export const offset = (state: AppState) => state.stores.offset

export const areaCode = (state: AppState) => state.stores.areaCode

export const filters = (state: AppState): StoreFiltersState =>
  state.stores.filters

export const searchTerm = (state: AppState) => state.stores.searchTerm

export const states = (state: AppState) => state.states.states

export const isSearchingByMapArea = createSelector(
  locationSelectors.radius,
  radius => typeof radius === 'number' && radius > 0,
)

export const storeList = createSelector(
  results,
  entities,
  (storeIds, stores) => {
    return storeIds
  },
)

export const selectedMarker = (state: AppState) => state.stores.selectedMarker

const selectedStoreId = (state: AppState) => state.stores.selectedStore

export const selectedStore = createSelector(
  entities,
  selectedStoreId,
  (stores, selectedStoreId) => stores[selectedStoreId],
)

const accessFilters = createSelector(filters, (filters: StoreFiltersState) => ({
  ...getAccessibilitySpecificFilters(filters),
}))

const departmentFilters = createSelector(
  filters,
  (filters: StoreFiltersState) => ({
    ...getBrandSpecificFilters(getConstants().BRAND, filters),
  }),
)

const otherFilters = (state: AppState) => ({
  areaCode: state.stores.areaCode,
})

const selectedStoreSizeFilter = createSelector(
  filters,
  (filters: StoreFiltersState) => filters.storeSize,
)

const activeFiltersOrder = createSelector(
  filters,
  (filters: StoreFiltersState) => filters.activeFiltersOrder,
)

const storeServiceFilters = createSelector(
  filters,
  (filters: StoreFiltersState) => ({
    utMe: filters.utMe,
    reUniqloStudio: filters.reUniqloStudio,
    customOrderWomen: filters.customOrderWomen,
    customOrderMen: filters.customOrderMen,
  }),
)

export const filterGroups = createSelector(
  departmentFilters,
  selectedStoreSizeFilter,
  accessFilters,
  otherFilters,
  activeFiltersOrder,
  storeServiceFilters,
  (
    departmentFilters,
    selectedStoreSizeFilter,
    accessFilters,
    otherFilters,
    activeFiltersOrder,
    storeServiceFilters,
  ) => ({
    departmentFilters,
    selectedStoreSizeFilter,
    accessFilters,
    otherFilters,
    activeFiltersOrder,
    storeServiceFilters,
  }),
)

export default root
